import React, { PropsWithChildren, useContext, useState } from "react";

export type SearchItem = {
  type: "popular" | "keyword" | "topic" | "teacher" | "placeholder";
  name?: string;
  uid: string;
  photo?: string | null;
  leaderLink?: string | null;
  category?: string;
};

export const SearchSuggestionsProvider = ({
  children,
  initialItem
}: PropsWithChildren<{ initialItem?: SearchItem }>) => {
  const [initialSelectedItem, _setInitialSelectedItem] = useState<
    SearchItem | undefined
  >(initialItem);

  function setInitialSelectedItem(item: SearchItem) {
    _setInitialSelectedItem(item);
  }

  return (
    <SearchSuggestionsContext.Provider
      value={{ initialSelectedItem, setInitialSelectedItem }}
    >
      {children}
    </SearchSuggestionsContext.Provider>
  );
};

export const SearchSuggestionsContext = React.createContext<
  | {
      initialSelectedItem: SearchItem | undefined;
      setInitialSelectedItem: (item: SearchItem) => void;
    }
  | undefined
>(undefined);

export const useSearchSuggestionsContext = () => {
  return useContext(SearchSuggestionsContext);
};
